// import { Outlet } from 'react-router-dom'
import { styled } from '@mui/material'
import { useState } from 'react'
import SectionErrorBoundary from '@/components/SectionErrorBoundary'
import { DocsNavProvider } from '@/features/docs/DocsNavProvider'
import { Docs } from '@/routes'
import DocsNavbar from './DocsNavbar'
import DocsSidebar from './DocsSidebar'

const DocsLayoutWrapper = styled('div')(({ theme }) => ({
    backgroundColor: theme.palette.background.paper,
    display: 'flex',
    height: '100dvh',
    overflow: 'hidden',
    paddingTop: 64,
    // viewport-fit=cover: keep content out of the notch in landscape.
    paddingLeft: 'env(safe-area-inset-left, 0px)',
    paddingRight: 'env(safe-area-inset-right, 0px)',
    [theme.breakpoints.up('lg')]: {
        paddingLeft: 256
    }
}))

const DocsLayoutContainer = styled('div')({
    flex: '1 1 auto',
    overflow: 'auto'
})

const DocsLayout = () => {
    const [isSidebarMobileOpen, setIsSidebarMobileOpen] = useState(false)

    return (
        // One nav fetch for the whole screen. The navbar's Categories menu,
        // the sidebar, the breadcrumbs and the browse pages all read it, and
        // four independent fetches would settle at four different moments
        // under the reader's cursor.
        <DocsNavProvider>
            <DocsNavbar
                onSidebarMobileOpen={() => setIsSidebarMobileOpen(true)}
            />
            <DocsSidebar
                onMobileClose={() => setIsSidebarMobileOpen(false)}
                openMobile={isSidebarMobileOpen}
            />
            <DocsLayoutWrapper>
                <DocsLayoutContainer>
                    <SectionErrorBoundary label="docs-content">
                        <Docs />
                    </SectionErrorBoundary>
                </DocsLayoutContainer>
            </DocsLayoutWrapper>
        </DocsNavProvider>
    )
}

export default DocsLayout
